function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.477 2 2 6.59 2 12.253c0 4.53 2.865 8.373 6.839 9.729.5.094.682-.222.682-.494 0-.243-.008-.888-.013-1.744-2.782.62-3.369-1.374-3.369-1.374-.454-1.185-1.11-1.5-1.11-1.5-.908-.636.069-.624.069-.624 1.003.073 1.531 1.057 1.531 1.057.892 1.567 2.341 1.114 2.91.852.092-.662.35-1.114.636-1.37-2.22-.26-4.555-1.139-4.555-5.068 0-1.119.39-2.035 1.029-2.751-.103-.26-.446-1.302.098-2.714 0 0 .84-.275 2.75 1.052A9.357 9.357 0 0112 6.958c.85.004 1.705.118 2.504.346 1.909-1.327 2.747-1.052 2.747-1.052.546 1.412.203 2.455.1 2.714.64.716 1.028 1.632 1.028 2.751 0 3.94-2.339 4.806-4.566 5.06.359.316.678.942.678 1.898 0 1.37-.012 2.477-.012 2.813 0 .274.18.593.688.493C19.137 20.622 22 16.782 22 12.253 22 6.59 17.522 2 12 2",
  fill: "#333",
  fillRule: "evenodd"
});

function SvgIcGithub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgIcGithub;